import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import HeaderButtonDropdown from "./HeaderButtonDropdown";

createRoot(document.getElementById("tmt-header-button-dropdown")).render(
  <StrictMode>
    <HeaderButtonDropdown />
  </StrictMode>
);
